var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "card align-center" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("h1", [
              _vm._v("Bem-vindo(a) à nova forma de contratar faxinas!")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: { to: { name: "purchase-flow" } },
                on: { click: _vm.clickedOnScheduleCleanup }
              },
              [
                _c("button", { staticClass: "btn bg-purple mt-20" }, [
                  _vm._v("agendar limpeza")
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row text-center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card pt-50" }, [
          _c("i", { staticClass: "icon sprinkler" }),
          _vm._v(" "),
          _c("div", { staticClass: "card-title" }, [_vm._v("Produtos")]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-5" }, [
            _vm._v(
              "\n        Os profissionais levam os produtos para a limpeza. Mas se você preferir usar os seus, tudo bem.\n        "
            ),
            _c(
              "small",
              {
                staticClass: "text-purple pointer",
                on: {
                  click: function($event) {
                    _vm.showProductsList = true
                  }
                }
              },
              [_c("b", [_vm._v("Ver os produtos")])]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _vm.showProductsList
        ? _c(
            "modal",
            {
              attrs: { title: "LISTA DE PRODUTOS", size: "md" },
              on: {
                close: function($event) {
                  _vm.showProductsList = false
                }
              }
            },
            [
              _c("template", { slot: "body" }, [
                _c("div", [
                  _vm._v(
                    "\n        A lista de produtos varia de cada profissional, mas todos eles levam, no mínimo, os seguintes ítens:\n        "
                  ),
                  _c("ul", [
                    _c("li", [_vm._v("(500ml) Desinfetante de uso geral")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(200ml) Limpador multiuso")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(200ml) Detergente")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(200ml) Álcool líquido 70%")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(100ml) Lustra móveis")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(1 litro) Água sanitária")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(1 par) de Luvas de borracha")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(4) Panos de chão")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(6) Flanelas")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(1) Esponja")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(1) Esponja de aço")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(3) Sacos de lixo")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("(1) Pincel")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn bg-purple-outline",
                    on: {
                      click: function($event) {
                        _vm.showProductsList = false
                      }
                    }
                  },
                  [_vm._v("fechar")]
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("\n        Você está na\n        "),
      _c("b", [_vm._v("Donamaid")]),
      _vm._v(".\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card pt-50" }, [
      _c("i", { staticClass: "icon shield-checked" }),
      _vm._v(" "),
      _c("div", { staticClass: "card-title" }, [_vm._v("Profissionais")]),
      _vm._v(" "),
      _c("p", { staticClass: "mt-5" }, [
        _vm._v(
          "Os profissionais na plataforma donamaid são experientes, amigáveis e com antecedentes verificados."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card pt-50" }, [
      _c("i", { staticClass: "icon clock" }),
      _vm._v(" "),
      _c("div", { staticClass: "card-title" }, [_vm._v("Faxinas na medida")]),
      _vm._v(" "),
      _c("p", { staticClass: "mt-5" }, [
        _vm._v(
          "Agende de forma fácil, limpezas de vários tamanho, inclusive para o dia seguinte."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 